import { BrowserContext } from "../contexts/BrowserContext"

const Sidebar = () => {

    return (
        <BrowserContext.Consumer>
        {({browserContextData, setBrowserContextData}) => {
            var i = 0
            const sidebarItems = browserContextData['sidebarSelections']
            .sort((a, b) => (a > b))
            .map(element => (
                <>
                    {/* RADIO */}
                    <input 
                    key={element + 'input' + i++}
                    className='uiRadio' 
                    type="radio" 
                    id={element} 
                    name="sidebar" 
                    value={element} 
                    />

                    {/* RADIO LABEL */}
                    <label 
                    key={element + 'label' + i++}
                    className='uiRadioLabel sidebarItem josefin-light' 
                    htmlFor={element}
                    onClick={() => {
                        setBrowserContextData({...browserContextData, 'sidebarSelected' : element})
                        
                        document.getElementById('canvas').scrollTop = 0
                        document.getElementById('canvas').classList.add('floatUp')
                        document.getElementById('canvas')
                        .addEventListener('animationend', () => {
                            if (document.getElementById('canvas').classList.contains('floatUp'))
                                document.getElementById('canvas').classList.remove('floatUp')
                        }, { once: true })
                    }}
                    >
                    {element}
                    </label>
                </>
            ))

            return (

                <div className='sidebar' key={'sidebarItems'}>

                    <input 
                        key={'sidebarSearch'}
                        className='uiRadio' 
                        type="radio" 
                        id='sidebarSearch' 
                        name="sidebar" 
                        value="sidebarSearch" 
                    />
                    
                    <input className="sidebarSearch uiRadioLabel sidebarItem josefin-light" 
                    id="sidebarSearchInput" 
                    placeholder="🔎 find"

                    onFocus={() => {
                        document.getElementById('sidebarSearch').checked = true
                        setBrowserContextData(
                            { ...browserContextData, 'sidebarSelected' : 'sidebarSearch' }
                        )
                    }}

                    onInput={(e) => {

                        var value = e.target.value

                        value = value.replaceAll('🔎 ', '')

                        var searchTerms = value.trim().split(' ').filter(a => a !== " ")

                        setBrowserContextData(
                            { ...browserContextData, 'sidebarSearchInput' : value, 'searchTerms' : searchTerms }
                        )
                        
                        e.target.value = (value === '') ?  '' : '🔎 ' + value
                    }}

                    onKeyDown={(e) => {

                        if (e.code === 'Space') {

                            if (e.target.value === '') e.preventDefault()

                            e.target.value = e.target.value.trimEnd()
                        }

                    }}

                    />

                    {sidebarItems}

                </div>
            )
        }}
        </BrowserContext.Consumer>
    )
}

export default Sidebar